import React, { useState, useEffect } from 'react'
import Header from '../components/layout/Header'
import CinemaInfo from '../components/sinema/CinemaInfo'
import MovieCard from '../components/sinema/MovieCard'
import MovieDetailModal from '../components/sinema/MovieDetailModal'
import { moviesApi } from '../services/api'
import CinemaPhoto from '@/components/sinema/CinemaPhoto'
import seansApi from '@/services/api/seansApi'
import TicketService from '@/services/api/ticketService'
import Tickets from '@/components/sinema/Tickets'

const Cinema = () => {
  const [movies, setMovies] = useState([])
  const [tickets, setTickets] = useState([])
  const [selectedMovie, setSelectedMovie] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    loadMovies()
  }, [])

  const loadMovies = async () => {
    try {
      setLoading(true)
      setError(null)
      const response = await TicketService.getAll()

      setTickets(response.my_tickets)

      const formattedMovies = response.item.dates.map((movie) => ({
        ...movie,
        date: formatDate(movie.date),
      }))
      setMovies(formattedMovies)
    } catch (err) {
      setError('Filmler yüklenirken bir hata oluştu')
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('tr-TR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })
  }

  const handleMovieClick = (movie) => {
    setSelectedMovie(movie)
  }

  const handleCloseModal = () => {
    setSelectedMovie(null)
  }

  return (
    <div className='min-h-screen'>
      <Header title='Sinema Salonu' showBack />

      <div className='p-3 space-y-6'>
        {/* Film Afişi */}
        <CinemaPhoto />

        {/* Salon Bilgileri */}
        <CinemaInfo />

        {/* Biletlerim */}
        <Tickets tickets={tickets} />

        {/* Seanslar */}
        <div>
          <h2 className='text-xl font-bold text-gray-800 mb-2'>Seanslar</h2>
          {loading ? (
            <div className='bg-white rounded-xl p-8 text-center'>
              <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-[#AC5E2A] mx-auto mb-4'></div>
              <p className='text-gray-600'>Yükleniyor...</p>
            </div>
          ) : movies.length > 0 ? (
            <div className='grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4'>
              {movies.map((movie) => (
                <MovieCard key={movie.hour_id} movie={movie} onClick={() => handleMovieClick(movie)} checkControl={movie.yetkili} />
              ))}
            </div>
          ) : (
            <div className='bg-[#AC5E2A] text-white rounded-xl p-6 text-center'>
              <p className='text-lg font-semibold mb-2'>Film Programı</p>
              <p className='opacity-90'>Film programı yakında paylaşılacak</p>
            </div>
          )}
        </div>
      </div>

      {/* Movie Detail Modal */}
      {selectedMovie && <MovieDetailModal movie={selectedMovie} onClose={handleCloseModal} />}
    </div>
  )
}

export default Cinema
